(() => {
  const initGalleryProgress = () => {

    const gallery =
      document.getElementById('product-gallery');

    const counter =
      document.getElementById('gallery-counter');

    if (!gallery || !counter) return;

    const track =
      gallery.querySelector('.ma-pdp-gallery-track');

    if (!track) return;

    const slides =
      Array.from(
        gallery.querySelectorAll('.ma-pdp-media')
      );

    const totalSlides = slides.length;

    if (totalSlides <= 1) {
      counter.style.display = 'none';
      return;
    }

    if (window.innerWidth <= 989) {
      counter.style.display = 'block';
    } else {
      counter.style.display = 'flex';
    }
    let ticking = false;

    const update = () => {

      const maxScroll =
        track.scrollWidth - track.clientWidth;

      const scrollLeft =
        Math.max(0, track.scrollLeft);

      const progress =
        maxScroll > 0
          ? Math.min(
              Math.max(scrollLeft / maxScroll, 0),
              1
            )
          : 0;

      const trackWidth = 120;

      const thumbWidth =
        Math.max(trackWidth / totalSlides, 20);

      const thumbX =
        progress * (trackWidth - thumbWidth);

      const thumbEnd =
        thumbX + thumbWidth;

      const background =
        `linear-gradient(
          to right,
          #D0D0D0 0px,
          #D0D0D0 ${thumbX}px,
          #000000 ${thumbX}px,
          #000000 ${thumbEnd}px,
          #D0D0D0 ${thumbEnd}px,
          #D0D0D0 ${trackWidth}px
        )`;

      if (window.innerWidth <= 989) {
        counter.style.display = 'block';
        counter.style.setProperty(
          'background',
          background,
          'important'
        );
      } else {
        counter.style.removeProperty('display');
        counter.style.removeProperty('background');
      }

      ticking = false;
    };

    const onScroll = () => {
      if (ticking) return;

      ticking = true;

      requestAnimationFrame(update);
    };

    track.addEventListener(
      'scroll',
      onScroll,
      { passive: true }
    );

    window.addEventListener(
      'resize',
      update,
      { passive: true }
    );

    window.addEventListener(
      'orientationchange',
      update,
      { passive: true }
    );

    // Also update on load to handle initial state
    window.addEventListener(
      'load',
      update,
      { passive: true }
    );

    update();
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initGalleryProgress,
      { once: true }
    );
  } else {
    initGalleryProgress();
  }
})();
